module.exports = __webpack_public_path__ + "media/img/pages/companies/loterie-romande-3e68f2d36df197c5fefdb9c064c81fe2.png";